import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const ParcelTypesMedium: FC<SvgIconProps> = ({ viewBox = '0 0 255 170', ...props }) => (
  <SvgIcon viewBox={viewBox} fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <path d="M105.864 80.6014L206.833 62.4786L149.136 34L48.1667 51.7529L105.864 80.6014Z" fill="#FDDE84" />
    <path
      opacity="0.4"
      d="M81.0835 68.0264L182.053 50.2735L172.437 45.4654L71.0975 63.5882L81.0835 68.0264Z"
      fill="#AA7B33"
    />
    <path d="M105.864 80.6014V133.86L48.1667 105.012V51.7529L105.864 80.6014Z" fill="#C39000" />
    <path opacity="0.4" d="M81.0835 68.0264V87.9985L71.0975 82.8205V63.5882L81.0835 68.0264Z" fill="#AA7B33" />
    <path d="M105.864 80.6014V133.86L206.833 115.368V62.4786L105.864 80.6014Z" fill="#FCCE09" />
  </SvgIcon>
)
